import {
  ToggleGroup as ToggleGroupBase,
  type ToggleGroupRootProps,
} from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

type ToggleGroupDataType = {
  label: string;
  value: string;
  disabled?: boolean;
  icon?: React.ReactNode;
};
interface ToggleGroupProps extends ToggleGroupRootProps {
  data: ToggleGroupDataType[];
  size?: "xs" | "sm" | "md" | "lg";
  activeVariant?: "filled" | "outlined";
  variant?: "outlined" | "rounded";
  withCloseIcon?: boolean;
  onClose?: React.MouseEventHandler<HTMLSpanElement>;
  classNames?: {
    root?: string;
    item?: string;
    itemIcon?: string;
    closeIcon?: string;
  };
}

const ToggleGroup = React.forwardRef<
  React.ElementRef<typeof ToggleGroupBase.Root>,
  ToggleGroupProps
>((props, ref) => {
  const {
    data,
    className,
    classNames,
    size = "md",
    variant = "outlined",
    activeVariant = "outlined",
    ...rootProps
  } = props;

  return (
    <ToggleGroupBase.Root
      ref={ref}
      className={clsx("ox-reset ox-ChipsRoot", className, classNames?.root)}
      data-variant={variant}
      data-size={size}
      {...rootProps}
    >
      {data.map((item) => (
        <ToggleGroupBase.Item
          className={clsx("ox-reset ox-ChipsItem", classNames?.item)}
          data-size={size}
          disabled={item.disabled}
          data-variant={variant}
          data-active-variant={activeVariant}
          value={item.value}
          key={item.value}
        >
          {item.icon ? (
            <span
              data-variant={variant}
              aria-hidden
              className={clsx(
                "ox-reset ox-ChipsItemIcon",
                classNames?.itemIcon,
              )}
            >
              {item.icon}
            </span>
          ) : null}
          {item.label}
        </ToggleGroupBase.Item>
      ))}
    </ToggleGroupBase.Root>
  );
});

ToggleGroup.displayName = "ToggleGroup";
export { ToggleGroup };
export type { ToggleGroupProps };
